import { InstrumentT } from '@/common/types'

export type SecurityOrderItem = {
    requestId: string
    securityCode: string
    instrument: InstrumentT
    amount: number
    units: number
    weight: number
    relevantPrice: number
    hasLimitPriceError?: boolean
    hasAmountError?: boolean
    submissionStatus?: SubmissionStatus
}

export type ReadyMadeTotals = {
    totalAmount: number
    brokerage: number
    total: number
}

export enum SubmissionStatus {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
}
